// extracted by mini-css-extract-plugin
module.exports = {"image":"Fm-z","loaded":"Gm-z","placeholder":"Hm-z"};